import { IscApiError } from "./isc-client";

export function isApiOfflineError(err: unknown): boolean {
  return err instanceof IscApiError && err.status === 0;
}

export function isInsufficientStockError(err: unknown): boolean {
  return (
    err instanceof IscApiError &&
    /insufficient (available )?stock|reservation quantity lower/i.test(err.message)
  );
}
